import type { FormEventHandler, RefObject } from 'react'
import { IconSearch } from '../ui/icons'

interface SearchFieldProps {
  inputRef: RefObject<HTMLInputElement>
  value: string
  placeholder: string
  label: string
  onChange: (value: string) => void
  onSubmit: FormEventHandler<HTMLFormElement>
}

export function SearchField({
  inputRef,
  value,
  placeholder,
  label,
  onChange,
  onSubmit,
}: SearchFieldProps) {
  return (
    <form className="search" onSubmit={onSubmit}>
      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        // Select existing text on focus so re-tapping lets the customer type over it.
        onFocus={(event) => event.currentTarget.select()}
        placeholder={placeholder}
        aria-label={label}
        // Keep the mobile keyboard's action key aligned with the explicit submit button.
        enterKeyHint="search"
      />
      <button type="submit" className="search-submit" aria-label={label} title={label}>
        <IconSearch aria-hidden="true" />
      </button>
    </form>
  )
}
